import toastMessage from "../../toastMessage";
import { getStorage } from "../../storage";
import api from "../../api";
import language from "../../../language";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;
const getHeaders = async () => {
  const user = await getStorage();

  return {
    Authorization: user?.token ? `Bearer ${user.token}` : undefined,
  };
};

export const fetchSerologyResult = async (
  lng = "english",
  {
    page,
    limit,
    sampleId,
    messageId,
    senderApplication,
    tester,
    startDate,
    endDate,
    result,
  }
) => {
  try {
    const headers = await getHeaders();

    const options = {
      method: "GET",
      url: `${API_URL}/alinityResult`,
      params: {
        page,
        limit,
        sampleId,
        messageId,
        senderApplication,
        tester,
        startDate,
        endDate,
        result,
      },
      headers,
    };

    const queryRes = await api(options);
    const { data, count, totalRecords } = queryRes.data;

    return !page && !limit ? queryRes.data?.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteSerologyResult = async (lng = "english", id) => {
  try {
    const headers = await getHeaders();

    const options = {
      method: "DELETE",
      url: `${API_URL}/alinityResult`,
      data: {
        id,
      },
      headers,
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_test);
  } catch (error) {
    toastMessage("error", error);
  }
};

export const pushSerologyResult = async (lng = "english", id) => {
  try {
    const headers = await getHeaders();

    const options = {
      method: "POST",
      url: `${API_URL}/alinityResult`,
      data: { id },
      headers,
    };

    const res = await api(options);
    toastMessage("success", language[lng]?.success_push_serology || "Result pushed successfully");
    return res.data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const bulkRetrySerologyResult = async (lng = "english") => {
  try {
    const headers = await getHeaders();

    const options = {
      method: "POST",
      url: `${API_URL}/alinityResult/bulk-retry`,
      headers,
    };

    const res = await api(options);
    const { summary } = res.data;
    toastMessage(
      "success",
      `Bulk retry done — processed: ${summary.processed}, skipped: ${summary.skipped}, failed: ${summary.failed}`
    );
    return summary;
  } catch (error) {
    toastMessage("error", error);
  }
};
